import { apiClient } from './client';
import type { components } from './schema.gen';

/**
 * Dashboard endpoints — read-only aggregates served by the backend out
 * of materialised views (sprint 3' action 3'.9). Both endpoints take an
 * optional [from, to[ window in ISO 8601; absent values mean "last 90
 * days" on the backend side.
 */

export type ActorPerfRow = components['schemas']['ActorPerfRow'];
export type ByCommuneRow = components['schemas']['ByCommuneRow'];

export type DateRange = { from?: string; to?: string };

export async function getActorPerformance(range: DateRange = {}, limit = 50): Promise<ActorPerfRow[]> {
  const { data, error } = await apiClient.GET('/v1/admin/dashboards/actor-performance', {
    params: { query: { from: range.from ?? '', to: range.to ?? '', limit } },
  });
  if (error || !data) return [];
  return (data.items ?? []) as ActorPerfRow[];
}

export async function getByCommune(range: DateRange = {}, limit = 100): Promise<ByCommuneRow[]> {
  const { data, error } = await apiClient.GET('/v1/admin/dashboards/by-commune', {
    params: { query: { from: range.from ?? '', to: range.to ?? '', limit } },
  });
  if (error || !data) return [];
  return (data.items ?? []) as ByCommuneRow[];
}
